import { useMutation } from "@tanstack/react-query"
import { createVersionFetch } from "store/middlewares/assessment.crud"

const useCreateVersion = () => {
    const { mutateAsync: createVersion, loading } = useMutation({
        mutationFn: createVersionFetch
    })

    return {
        createVersion,
        loading
    }
}

export default useCreateVersion